<template>
  <el-card>
    <el-form :inline="true" :model="searchFactor" class="search-form">
      <el-form-item label="主题:" >
        <el-input v-model="searchFactor.theme"></el-input>
      </el-form-item>
      <el-form-item label="状态:" >
        <el-select style="width:100%"  v-model="searchFactor.active" placeholder="活动区域">
          <el-option label="全部" value=""></el-option>
          <el-option label="激活" value="1"></el-option>
          <el-option label="禁用" value="0"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="实验室准入教程:" >
        <el-select v-model="searchFactor.basicState" placeholder="请选择" style="width:200px">
          <el-option  label= "全部" value="" ></el-option>
          <el-option  label= "是" value="1" ></el-option>
          <el-option  label= "否" value="0" ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch">查询</el-button>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="handleCreateExam">创建</el-button>
      </el-form-item>
    </el-form>
    <el-table
      :data="tableData"
      :stripe ="true"
      :border = "true"
      ref="multipleTable"
      :highlight-current-row ="false"
      height="calc(100vh - 200px)"
      max-height="calc(100vh - 200px)"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 100%">
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="theme"
        label="主题"
        min-width="150px" >
      </el-table-column>
      <el-table-column
        prop="basicState"
        label="实验室准入教程"
        min-width="70">
        <template slot-scope="scope">
          <span v-if = "scope.row.basicState == 1" style="color: greenyellow"> 是</span>
          <span v-else style="color: red" > 否</span>
        </template>
      </el-table-column>
      <!-- <el-table-column
        prop="moduleName"
        label="模块"
        min-width="150px" >
      </el-table-column> -->
      <el-table-column
        prop="beginTime"
        label="开始时间"
        min-width="100px">
      </el-table-column>
      <el-table-column
        prop="endTime"
        label="结束时间"
        min-width="100px" >
      </el-table-column>
      <el-table-column
        prop="totalScore"
        label="总分数"
        min-width="60px">
      </el-table-column>
      <el-table-column
        prop="passScore"
        label="及格分数"
        min-width="60px">
      </el-table-column>
      <el-table-column
        prop="duration"
        label="考试时长"
        min-width="60px">
      </el-table-column>
      <el-table-column
        prop="quantity"
        label="题目数"
        min-width="60px">
      </el-table-column>
      <el-table-column
        prop="desc"
        label="描述"
        width="200">
      </el-table-column>
      <el-table-column
      prop="active"
      min-width="80px"
      label="状态" >
      <template slot-scope="scope">
          <span v-if = "scope.row.active == 0" style="color: red"> 未发布</span>
          <span v-else style="color: greenyellow" > 已发布</span>
      </template>
    </el-table-column>
      <el-table-column
        prop="createUser"
        label="创建者"
        width="120">
      </el-table-column>
      <el-table-column
        prop="createTime"
        label="创建时间"
        min-width="100px">
      </el-table-column>
      <el-table-column label="操作" min-width="120px">
        <template slot-scope="scope" >
          <el-dropdown split-button type="primary" @command="handleCommand">
            管理
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item divided :command = '{event:"doActiveExamTheme",index:scope.$index, data:scope.row}'>
                <i :class="scope.row.active == 0 ? 'el-icon-star-on':'el-icon-star-off' "  :style="scope.row.active == 0 ?'color:rgb(40, 238, 10)' :'color:rgb(246, 102, 18)'" ></i> 
                <span>{{scope.row.active == 0?'发布':'撤销'}}</span>
              </el-dropdown-item>
              <el-dropdown-item v-if ="scope.row.active == 0" divided :command = '{event:"handleEdit",index:scope.$index, data:scope.row}'><i class="el-icon-edit" style="color:rgb(241, 157, 100)"></i> <span>修改考试</span></el-dropdown-item>
              <el-dropdown-item v-if ="scope.row.active == 0" divided :command = '{event:"delete", index:scope.$index,data:scope.row}'><i class="el-icon-delete-solid" style="color:rgb(246, 102, 18)" ></i> <span>删除考试</span></el-dropdown-item>
              <el-dropdown-item v-if ="scope.row.active == 0" divided :command = '{event:"handleConfigPaper",index:scope.$index, data:scope.row}'><i class="el-icon-setting" style="color:rgb(231, 39, 42)"></i> <span>配置试卷</span></el-dropdown-item>
              <el-dropdown-item v-if = "scope.row.state > 1" divided :command = '{event:"sendPaper",index:scope.$index, data:scope.row}'><i class="el-icon-share" style="color:rgb(12, 139, 16)"></i> <span>分发试卷</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleViewPaper",index:scope.$index, data:scope.row}'><i class="el-icon-search" style="color:rgb(39, 193, 231)"></i> <span>预览试卷</span></el-dropdown-item>
              <el-dropdown-item divided :command = '{event:"handleViewReport",index:scope.$index, data:scope.row}'><i class="el-icon-s-data" style="color:rgb(39, 193, 231)"></i> <span>考试详情</span></el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      layout="total,prev, pager, next"
      @current-change="handleCurrentChange"
      :page-size="pager.pageSize"
      :total="pager.totalCount" >
    </el-pagination>
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisual.initExamThemeVisual" v-on:close ="clearInitExamThemeForm" >
      <div slot="title" class="dialog-footer">
        <span> 初始化一场考试 </span>
      </div>
      <el-form  label-position="right" label-width="20%" :model="initFormExamTheme">
        <el-form-item style="width:90%" label="考试题目:">
            <el-input v-model="initFormExamTheme.theme" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item style="width:90%" label="实验室准入教程:" >
          <el-checkbox v-model="initFormExamTheme.basicState"></el-checkbox>
        </el-form-item>
        <!-- <el-form-item style="width:90%" label="模块和类型:">
          <el-select style="width:100%" v-model="initFormExamTheme.moduleId" placeholder="请选择" >
            <el-option
              v-for="item in qmInfoList"
              :key="item.id"
              :label="item.moduleName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item style="width:90%" label="开始时间:">
          <el-col :span="5">
            <el-date-picker type="date" 
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
            v-model="initFormExamTheme.startDate" style="width: 100%;">
          </el-date-picker>
          </el-col>
          <el-col :span ="5">
            <el-time-picker
            v-model="initFormExamTheme.beginTime"
            style="width: 100%"
            value-format="HH:mm:ss"
            placeholder="开始日期:">
          </el-time-picker>
          </el-col>
          <el-col class="line" :span="4">结束日期:</el-col>
          <el-col :span="5">
            <el-date-picker
             value-format="yyyy-MM-dd"
             placeholder="结束日期"
             v-model="initFormExamTheme.endDate"
             style="width: 100%;">
            </el-date-picker>
          </el-col>
          <el-col :span ="5">
            <el-time-picker
            v-model="initFormExamTheme.endTime"
                style="width: 100%"
                value-format="HH:mm:ss"
            placeholder="结束时间">
          </el-time-picker>
        </el-col>
        </el-form-item>
        <el-form-item style="width:90%" label= '总分数:'>
          <el-col  :span ="10">
            <el-input  style="width: 100%" v-model="initFormExamTheme.totalScore" placeholder="总分数" autocomplete="off"></el-input>
          </el-col>
          <el-col class="line" :span="4">及格分数:</el-col>
          <el-col :span ="10">
            <el-input  style="width: 100%" v-model="initFormExamTheme.passScore" placeholder="合格分数" autocomplete="off"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item style="width:90%" label= '答题时间:'>
          <el-col  :span ="10">
            <el-input  style="width: 100%" v-model="initFormExamTheme.duration" placeholder="答题时长(分钟)" autocomplete="off"></el-input>
          </el-col>
          <el-col class="line" :span="4">题目数:</el-col>
          <el-col :span ="10">
            <el-input  style="width: 100%" v-model="initFormExamTheme.quantity" placeholder="题目数" autocomplete="off"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item style="width:90%"  label="描述:">
            <el-input type="textarea"  rows = 2 v-model="initFormExamTheme.desc" autocomplete="off"></el-input>
          </el-form-item>
      </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="ensureCreate">创建</el-button> 
        </div>
    </el-dialog>
    

    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisual.editExamThemeVisual" v-on:close ="clearEditExamThemeForm" >
      <div slot="title" class="dialog-footer">
        <span> 修改考试信息</span>
      </div>
      <el-form  label-position="right" label-width="20%" :model="editFormExamTheme">
        <el-form-item style="width:90%" label="考试题目:">
            <el-input v-model="editFormExamTheme.theme" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item style="width:90%"  label="实验室准入教程:" >
          <el-checkbox disabled v-model="editFormExamTheme.basicState"></el-checkbox>
        </el-form-item>
        <!-- <el-form-item style="width:90%" label="模块和类型:">
          <el-select style="width:100%" v-model="editFormExamTheme.moduleId" placeholder="请选择" >
            <el-option
              v-for="item in qmInfoList"
              :key="item.id"
              :label="item.moduleName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item style="width:90%" label="开始时间:">
          <el-col :span="5">
            <el-date-picker type="date" 
            placeholder="开始日期"
            value-format="yyyy-MM-dd"
            v-model="editFormExamTheme.startDate" style="width: 100%;">
          </el-date-picker>
          </el-col>
          <el-col :span ="5">
            <el-time-picker
            v-model="editFormExamTheme.beginTime"
            style="width: 100%"
            value-format="HH:mm:ss"
            placeholder="开始日期:">
          </el-time-picker>
          </el-col>
          <el-col class="line" :span="4">结束日期:</el-col>
          <el-col :span="5">
            <el-date-picker
             value-format="yyyy-MM-dd"
             placeholder="结束日期"
             v-model="editFormExamTheme.endDate"
             style="width: 100%;">
            </el-date-picker>
          </el-col>
          <el-col :span ="5">
            <el-time-picker
            v-model="editFormExamTheme.endTime"
                style="width: 100%"
                value-format="HH:mm:ss"
            placeholder="结束时间">
          </el-time-picker>
        </el-col>
        </el-form-item>
        <el-form-item style="width:90%" label= '总分数:'>
          <el-col  :span ="10">
            <el-input  style="width: 100%" v-model="editFormExamTheme.totalScore" placeholder="总分数" autocomplete="off"></el-input>
          </el-col>
          <el-col class="line" :span="4">及格分数:</el-col>
          <el-col :span ="10">
            <el-input  style="width: 100%" v-model="editFormExamTheme.passScore" placeholder="合格分数" autocomplete="off"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item style="width:90%" label= '答题时间:'>
          <el-col  :span ="10">
            <el-input  style="width: 100%" v-model="editFormExamTheme.duration" placeholder="答题时长(分钟)" autocomplete="off"></el-input>
          </el-col>
          <el-col class="line" :span="4">题目数:</el-col>
          <el-col :span ="10">
            <el-input  style="width: 100%" v-model="editFormExamTheme.quantity" placeholder="题目数" autocomplete="off"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item style="width:90%"  label="描述:">
            <el-input type="textarea"  rows = 2 v-model="editFormExamTheme.desc" autocomplete="off"></el-input>
          </el-form-item>
      </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button type="primary" @click="ensureEdit">确定修改</el-button> 
        </div>
    </el-dialog>


    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisual.configPagerVisual" v-on:close ="clearPaperConfigForm" >
      <div slot="title" class="dialog-footer">
        <span> 配置试卷 </span>
      </div>
      <el-steps :active=" configPagerForm.state" simple>
        <el-step  align-center  title="题型配置" icon="el-icon-edit"></el-step>
        <el-step align-center  title="选择题目" icon="el-icon-upload"></el-step>
      </el-steps>
      <div>
        <div class="demo-input-suffix"  style="margin-top:20px;text-align: center;"  v-for="(item,index) in configPagerForm.questionConfigList" :key="index">
          <el-tag type="warning"> {{(index +1) + '.' + item.answerCheckType.slice(0,3)}}</el-tag>
          <span>题目数量:</span>
          <el-input style="width:20%"  v-model="item.quantity">
          </el-input>
          <span>每题分数:</span>
          <el-input style="width:20%" v-model="item.oneScore">
          </el-input>
          <el-button type="primary" @click="configTitle(item.answerCheckType,index)">选择题目</el-button>
          <el-tag type="primary" style="margin-left:20px"> {{'已选' +item.selectCount +'题' }}</el-tag>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button v-if = "configPagerForm.state == 1" type="primary" @click="ensureCreateConfig">配置题型</el-button>
        <el-button v-else   type="primary" @click="ensureUpdateConfig">修改题型</el-button>
        <el-button  v-if = "configPagerForm.state > 1" type="primary" @click="randomOtherTitle">随机剩余题目</el-button>
        <el-button  v-if = "configPagerForm.state == 1" type="primary" @click="defaultConfig">启用默认配置</el-button> 
        <el-button type="primary" @click="testScore">校验分数</el-button>
      </div>
    </el-dialog>
    
    <!-- 选择试题弹框 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisual.configTitleVisual" fullscreen   v-on:close ="clearTitleConfigForm" >
       <div slot="title" style="text-align: left">
          <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
          <span style="font-size:18px;  font-weight:700">配置{{searchTitleFactor.answerCheckType}}</span>
      </div> 
      <el-form :inline="true" :model="searchTitleFactor" class="demo-form-inline">
        <el-form-item label="唯一码:" >
          <el-input v-model="searchTitleFactor.uniqNo"></el-input>
        </el-form-item>
        <el-form-item label="问题:" >
          <el-input v-model="searchTitleFactor.question"></el-input>
        </el-form-item>
        <el-form-item label="模块:">
          <el-select style="width:150px" v-model="searchTitleFactor.moduleId" placeholder="请选择" >
            <el-option
              label="全部"
              value="">
            </el-option>
            <el-option
              v-for="item in qmInfoList"
              :key="item.id"
              :label="item.moduleName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选中:" >
          <el-select style="width:100%"  v-model="searchTitleFactor.selected" placeholder="活动区域">
            <el-option label="全部" value=""></el-option>
            <el-option label="选中" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onQbSearch">查询</el-button>
        </el-form-item>
    </el-form>
    
    <el-table
      :data="tableTitleData"
      :stripe ="true"
      :border = "true"
      ref="multipleTitileTable"
      :highlight-current-row ="false"
      height="calc(100vh - 250px)"
      max-height="calc(100vh - 250px)"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 100%">
      <el-table-column
        type="index"
        label="序号"
        :index="indexMethod">
      </el-table-column>
      <el-table-column
        prop="moduleName"
        label="模块"
        min-width="120px" >
      </el-table-column>
      <el-table-column
        prop="uniqNo"
        label="唯一码"
        min-width="80px" >
      </el-table-column>
      <el-table-column
        prop="answerCheckType"
        label="类型"
        min-width="120px" >
      </el-table-column><el-table-column
        prop="basicState"
        label="实验室准入教程"
        min-width="70">
        <template slot-scope="scope">
          <span v-if = "scope.row.basicState == 1" style="color: greenyellow"> 是</span>
          <span v-else style="color: red" > 否</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="question"
        label="问题"
       min-width="250px">
      </el-table-column>
      <el-table-column
        prop="option"
        label="选项"
        min-width="200px"  :formatter="formatContent">
      </el-table-column>
      <el-table-column
        prop="answer"
        label="答案"
       min-width="100px">
      </el-table-column>
      <el-table-column
        prop="analysis"
        label="解析"
        min-width="200px">
      </el-table-column>
      <el-table-column
      prop="active"
      min-width="70px"
      label="状态" >
      <template slot-scope="scope">
        <span v-if = "scope.row.active == 1" style="color: greenyellow"> 已激活</span>
        <span v-else style="color: red" > 禁用</span>
      </template>
    </el-table-column>
      <el-table-column
      prop="active"
      min-width="80px"
      label="选中状态" >
      <template slot-scope="scope">
        <span v-if = "scope.row.selected == 1" style="color:greenyellow"> 已选中</span>
        <span v-else style="color: red" > 未选中</span>
      </template>
    </el-table-column>
      <el-table-column label="操作"    min-width="80px">
        <template slot-scope="scope">
          <el-button
          size="mini" 
          :type="scope.row.selected == 0 ? 'warning' :'success'"
          @click="handleSelected(scope.$index, scope.row)">{{scope.row.selected == 0?'选中':'移除'}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    
      <div slot="footer" class="dialog-footer">
        <el-pagination
          background
          layout="total,prev, pager, next"
          @current-change="handleTitleCurrentChange"
          :page-size="titlePager.pageSize"
          :current-page.sync="titlePager.curPage"
          :total="titlePager.totalCount">
        </el-pagination>
      </div>
    </el-dialog>
  
    <!--  -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisual.configUserVisual" fullscreen v-on:close ="clearUserPaperForm" >
      <div slot="title" style="text-align: left">
          <span style="margin-left: 5px; height:16px;width:10px;background:#38e8eb; display: inline-block"> </span>
          <span style="font-size:18px;  font-weight:700">分发试卷</span>
      </div> 
      <el-form :inline="true" :model="searchUserFactor" class="demo-form-inline">
        <el-form-item label="用户名:" >
          <el-input v-model="searchUserFactor.userName"></el-input>
        </el-form-item>
        <el-form-item label="姓名:" >
          <el-input v-model="searchUserFactor.fullName"></el-input>
        </el-form-item>
        <el-form-item label="部门:" >
          <el-select v-model="searchUserFactor.deptId" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in searchUserFactor.deptOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="选中:" >
          <el-select style="width:100%"  v-model="searchUserFactor.selected" placeholder="请选择">
            <el-option label="全部" value=""></el-option>
            <el-option label="已经分发" value="1"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onUserSearch">查询</el-button>
          <el-button type="primary" @click="sendAllPeople">全部分发</el-button>
        </el-form-item>
      </el-form>
    <el-table
      :data="tableUserData"
      :stripe ="true"
      :border = "true"
      :highlight-current-row ="false"
      height="calc(100vh - 250px)"
      max-height="calc(100vh - 250px)"
      :header-cell-style="{'text-align':'center'}"
      :cell-style="{'text-align':'center'}"
      style="width: 100%">
    <el-table-column
      type="index"
      label="序号"
      :index="indexMethod">
    </el-table-column>
    <el-table-column
      prop="fullName"
      label="姓名"
     min-width="150px">
    </el-table-column>
    <el-table-column
      prop="usrName"
      label="用户名"
      min-width="150px"
      width="120">
    </el-table-column>
    <el-table-column
      prop="mobilePhone"
      label="手机"
      min-width="180px">
    </el-table-column>
    <el-table-column
      prop="email"
      min-width="200px"
      label="邮件">
    </el-table-column>
    <el-table-column
      prop="deptName"
      min-width="280px"
      label="团队">
    </el-table-column>
    <el-table-column
      prop="gentle"
      min-width="50px"
      label="性别" :formatter="formatGentle">
    </el-table-column>
    <el-table-column
      prop="active"
      min-width="70px"
      label="状态" >
      <template slot-scope="scope">
          <span v-if = "scope.row.active == 1" style="color: greenyellow">  激活</span>
          <span v-else  style="color: red" > 禁用</span>
      </template>
    </el-table-column>
    <el-table-column label="操作" min-width="120px">
      <template slot-scope="scope">
        <el-button
        size="mini" 
        :type="scope.row.selected == 0 ? 'warning' :'success'"
        @click="handleSendPaper(scope.$index, scope.row)">{{scope.row.selected == 0?'选中':'移除'}}</el-button>
      </template>
    </el-table-column>
    </el-table>
    <el-pagination style="margin: 10px;"
      background
      layout="total,prev, pager, next"
      @current-change="handleUserCurrentChange"
      :page-size="userPager.pageSize"
      :current-page.sync="userPager.curPage"
      :total="userPager.totalCount">
    </el-pagination>
      <div slot="footer" class="dialog-footer">
      </div>
    </el-dialog>

    <!-- 打开试题预览界面 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisual.viewPaperVisual" fullscreen  v-on:close ="clearPaperViewForm" >
      <el-col :span="6" style="">
        <el-card style="height:calc(25vh - 10px);margin-top: 10px; overflow:auto;">
          <div  class="clearfix">
            <el-tag type ="mini" >
              {{ viewThemeOneDetail.theme }}
            </el-tag>
            <!-- <el-tag type ="mini">
              {{ viewThemeOneDetail.moduleName }}
            </el-tag> -->
          </div>
          <div >
            <div style="margin-top : 5px">总分数: {{ viewThemeOneDetail.totalScore }}分 </div>
            <div style="margin-top : 5px">及格分数:{{ viewThemeOneDetail.passScore }}分 </div>
            <div style="margin-top : 5px">考试时长:{{ viewThemeOneDetail.duration }}分钟 </div>
            <div style="margin-top : 5px">注意:少选，多选，错选不得分 </div>
          </div>
        </el-card>
        <el-card style="height:calc(60vh - 10px);margin-top:calc(1vh);overflow:auto;">
          <div v-for = "(item,index) in viewThemeOneDetail.qtList" :key="index" style="margin-top:10px">
            <el-tag type ="mini"> {{item.answerCheckType}}</el-tag><span style="padding-left:10px;">{{'共' +item.qbList.length+ '题,' }}</span>
            <span >{{'每题' +item.oneScore+ '分,'}}</span>
            <span>{{'共' + (item.qbList.length * item.oneScore) + '分' }}</span>
            <el-checkbox-group v-model="viewPaperCheckList"  @change="selectedOne" >
              <el-checkbox   v-for = "(ite,index) in item.qbList" :key="ite.id"  :label="ite.id.toString()"> {{index + 1  }}</el-checkbox>
            </el-checkbox-group>
          </div>
        </el-card>
      </el-col>
      <el-col :span="18">
        <el-card style="height:calc(86vh - 19px);margin-top:10px;margin-left:20px; overflow:auto;">
          <div slot="header" class="clearfix">
          <el-tag type="warning">{{ qbView.uniqNo }}</el-tag>
          <el-tag>{{ qbView.moduleName }}</el-tag>
          <el-tag type="success">{{  qbView.answerCheckType }}</el-tag>
        </div>
        <div style ="margin-top: 10px;" >
          <el-tag type="warning">问题</el-tag>
          <span style ="margin-left: 10px;">{{qbView.question }}</span>
        </div>
        <div style ="margin-top: 10px;" v-if = "qbView.imageUrlList.length > 0"> 
          <el-tag type="warning" style="padding-top: 0px">图片</el-tag>
          <el-badge  v-for="(item,index) in qbView.imageUrlList" :key = "index"  :value="index + 1" class="item">
            <el-image   
              style="width: 100px; height: 100px;margin-left: 10px; "
              :src="item.url"
              :fit="'fit'"></el-image>
          </el-badge>
          </div>
          <div style ="margin-top: 10px;">
            <el-checkbox-group v-model="qbView.checkedOptList">
              <el-tag type="warning">选项</el-tag>
              <el-checkbox disabled style ="margin-left: 10px;"  v-for="(opt , index ) in qbView.optionValueArr" :label="index.toString()" :key="opt">{{opt}}</el-checkbox>
            </el-checkbox-group>
          </div>
          <div style ="margin-top: 10px;">
            <el-tag type="warning">答案</el-tag>
            <span style ="margin-left: 10px;"> {{qbView.answer }}</span>
          </div >
          <div style ="margin-top: 10px;">
            <el-tag type="warning">解析</el-tag>
            <span style ="margin-left: 10px;"> {{qbView.analysis }}</span>
          </div>
        </el-card>
      </el-col>
    </el-dialog>
    <!-- 查看該考試統計 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisual.reportPaperVisual" fullscreen  v-on:close ="clearPaperReportForm" >
      <el-col :span="6" style="">
        <el-card style="height:calc(30vh - 10px);margin-top: 10px; overflow:auto;">
          <div  class="clearfix">
            <el-tag type ="success" size="mini" >
              {{ reportThemeOneDetail.theme }}
            </el-tag>
            <!-- <el-tag type ="warning" size = "mini">
              {{ reportThemeOneDetail.moduleName }}
            </el-tag> -->
            <el-tag type ="info" v-if = "reportThemeOneDetail.state == 1" size = "mini">
              未开考
            </el-tag>
            <el-tag type ="success" v-else-if  = "reportThemeOneDetail.state == 2" size = "mini">
              已开考
            </el-tag>
            <el-tag type ="danger" v-else size = "mini">
              已结束
            </el-tag>
          </div>
            <div>
              <div style="margin-top : 5px">参考时间:{{ reportThemeOneDetail.beginTime }}到{{ reportThemeOneDetail.endTime }} </div>
              <div style="margin-top : 5px">总分数: {{ reportThemeOneDetail.totalScore }}分 </div>
              <div style="margin-top : 5px">及格分数:{{ reportThemeOneDetail.passScore }}分 </div>
              <div style="margin-top : 5px">考试时长:{{ reportThemeOneDetail.duration }}分钟 </div>
              <div style="margin-top : 5px">注意:少选，多选，错选不得分 </div>
            </div>
        </el-card>
        <el-card style="height:calc(59vh - 11px);margin-top:calc(1vh);overflow:auto;">
          <div>
            <el-tag size = "mini" type="warning">
              考试汇总
            </el-tag>
          </div>
          <el-progress color = "rgb(20, 27, 229)" :percentage="reportThemeOneDetail.totalUserPer" style="width:100%" :format ="formatTotalCount"></el-progress>
          <el-progress :percentage="reportThemeOneDetail.totalStudentPer" style="width:100%"  :format ="formatTotalStudentCount"></el-progress>
          <el-progress color = "rgb(39, 236, 82)" :percentage="reportThemeOneDetail.completeExamStudentPer"  :format ="formatCompleteStudentCount" style="width:100%" ></el-progress>
          <el-progress color = "rgb(39, 236, 82)" :percentage="reportThemeOneDetail.passStudentPer"  :format ="formatPassStudentCount" style="width:100%" ></el-progress>
          <el-progress color = "rgb(231, 22, 22)" :percentage="reportThemeOneDetail.unExamStudentPer"  :format ="formatUnExamStudentCount" style="width:100%"></el-progress>
          <el-progress :percentage="reportThemeOneDetail.inExamStudentPer"  :format ="formatInExamStudentCount" style="width:100%"></el-progress>
          <el-progress color = "rgb(35, 30, 30)" :percentage="reportThemeOneDetail.overTimeStudentPer"  :format ="formatOverExamStudentCount" style="width:100%"></el-progress>
        </el-card>
      </el-col>
      <el-col :span="18">
        <el-card style="height:calc(90vh - 19px); margin-top:10px;margin-left:20px; overflow:auto;">
          <el-form :inline="true" :model="searchUserExamFactor" class="search-form">
            <el-form-item label="用户名:" >
              <el-input v-model="searchUserExamFactor.userName" style="width:100px"></el-input>
            </el-form-item>
            <el-form-item label="姓名:" >
              <el-input v-model="searchUserExamFactor.fullName" style="width:100px"></el-input>
            </el-form-item>
            <el-form-item label="团队:" >
              <el-select v-model="searchUserExamFactor.deptId" style="width:150px" placeholder="请选择">
                <el-option label="全部" value=""></el-option>
                <el-option
                  v-for="item in searchUserFactor.deptOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="范围:" >
              <el-select  style="width:100px"  v-model="searchUserExamFactor.selected" placeholder="活动区域">
                <el-option label="全部" value=""></el-option>
                <el-option label="不参加考试" value="0"></el-option>
                <el-option label="参加考试" value="1"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="考生状态:" >
              <el-select style="width:100px"  v-model="searchUserExamFactor.usrState" placeholder="活动区域">
                <el-option label="全部" value=""></el-option>
                <el-option label="未答题" value="1"></el-option>
                <el-option label="答题中" value="2"></el-option>
                <el-option label="已交卷" value="3"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="考试结果:" >
              <el-select style="width:100px" v-model="searchUserExamFactor.result" placeholder="活动区域">
                <el-option label="全部" value=""></el-option>
                <el-option label="未通过" value="0"></el-option>
                <el-option label="通过" value="1"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onResultSearch">查询</el-button>
            </el-form-item>
          </el-form>
          <el-table
            :data="reportUserExamTable"
            :stripe ="true"
            :border = "true"
            ref="reportTable"
            :highlight-current-row ="false"
            height="calc(100vh - 280px)"
            max-height="calc(100vh - 280px)"
            :header-cell-style="{'text-align':'center'}"
            :cell-style="{'text-align':'center'}"
            style="width: 100%">
            <el-table-column
              type="index"
              label="序号"
              :index="indexMethod">
            </el-table-column>
            <el-table-column
              prop="fullName"
              label="姓名"
              min-width="60px" >
            </el-table-column>
            <el-table-column
              prop="usrName"
              label="用户名"
              min-width="80px" >
            </el-table-column>
            <el-table-column
              prop="deptName"
              label="团队"
              min-width="100px" >
            </el-table-column>
            <el-table-column 
              label="考试次数"
              min-width="80px" >
                <template slot-scope="item">
                  <el-dropdown  @command="handleCommandExam">
                    <span size="mini" style="margin-left:5px;cursor: pointer;" class="el-dropdown-link">
                      {{item.row.examCount}}次 <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-if = "item.row.examCount == 1"  divided  :command=" {row:item.row,  examLocalCount:1 }" >
                        <i :style="item.row.result == 1 ? 'color: #67C23A;':''" :class="item.row.result == 1 ? 'el-icon-success':'el-icon-warning'">当前考试 </i>
                      </el-dropdown-item>
                      <el-dropdown-item v-else  divided v-for=" (ite,index) in item.row.examCount" :command="{row:item.row,  examLocalCount:ite }" :key="index">
                        <i v-if = " ite == 1"  class="el-icon-warning"> 第1次考试 </i>
                        <i v-else-if = "ite < item.row.examCount && ite > 1  "  class="el-icon-warning">{{ ' 第' + (ite - 1) + '次重考'}} </i>
                        <i v-else :style="item.row.result == 1 ? 'color: #67C23A;':''" :class="item.row.result == 1 ? 'el-icon-success':'el-icon-warning'"> 当前考试</i>
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
            </el-table-column>
            <el-table-column
              prop="beginExamTime"
              label="开始时间"
              min-width="60px">
            </el-table-column>
            <el-table-column
              prop="commitExamTime"
              label="交卷时间"
              min-width="60px" >
            </el-table-column>
            <el-table-column
              prop="score"
              label="分数"
              min-width="40px">
            </el-table-column>
            <el-table-column
              prop="usrState"
              label="考试状态"
              min-width="60px">
              <template slot-scope="scope">
                <span v-if = "scope.row.usrState == 1" style="color: rgb(25, 0, 255)">未答题</span>
                <span v-else-if="scope.row.usrState == 2 &&  !scope.row.selfExamOver" style="color: rgb(245, 57, 15)" > 答题中</span>
                <span v-else-if="scope.row.usrState == 2 && scope.row.selfExamOver" style="color: rgb(245, 57, 15)" > 超时未交卷</span>
                <span v-else style="color: rgb(47, 255, 82)" > 已交卷</span>
              </template>
            </el-table-column>
            <el-table-column
            prop="result"
            min-width="60px"
            label="考试结果" >
            <template slot-scope="scope">
                <span v-if = "scope.row.usrState == 3 && scope.row.result == 0" style="color: red"> 未通过</span>
                <span v-else-if = "scope.row.usrState == 3 && scope.row.result == 1" style="color: greenyellow" > 通过</span>
              </template>
          </el-table-column>
            <el-table-column label="操作" min-width="120px">
              <template slot-scope="scope" >
                <el-dropdown split-button type="primary" @command="handleCommandOneStudent">
                  操作
                  <el-dropdown-menu slot="dropdown">
                    <!-- v-if ="scope.row.usrState == 2 && scope.row.selfExamOver"  -->
                    <el-dropdown-item  divided :command = '{event:"seeOneStudentPaper",index:scope.$index, data:scope.row}'><i class="el-icon-edit" style="color:rgb(107, 241, 100)"></i> <span>查看试卷</span></el-dropdown-item>
                    <el-dropdown-item  v-if = "scope.row.usrState == 2 && scope.row.selfExamOver"   divided :command = '{event:"getOneStudentPaper", index:scope.$index,data:scope.row}'><i class="el-icon-delete-solid" style="color:rgb(246, 102, 18)"  ></i> <span>收卷</span></el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination style="margin:10px"
            background
            layout="total,prev, pager, next"
            @current-change="handleReportChange"
            :page-size="reportPager.pageSize"
            :current-page="reportPager.curPage"
            :total="reportPager.totalCount" >
          </el-pagination>
        </el-card>
      </el-col>
    </el-dialog>
    <!-- 打開一個用戶的試卷 -->
    <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisual.oneStudentPaperVisual" fullscreen  v-on:close ="clearOneStudentPaperViewForm" >
      <el-col :span="7" style="">
        <el-card style="height:calc(25vh - 10px);margin-top: 10px;text-align: left; overflow:auto;">       
          <div  class="clearfix">
            <el-tag type ="warning"  size="mini" >
              {{ viewOneStudentDetail.fullName }}({{viewOneStudentDetail.usrName  }})
            </el-tag>
            <el-tag type ="success"  size="mini">
              {{ viewOneStudentDetail.deptName }}
            </el-tag>
          </div>
          <div  class="clearfix">
            <el-tag type ="mini" >
              {{ viewOneStudentDetail.theme }}
            </el-tag>
            <!-- <el-tag type ="mini">
              {{ viewOneStudentDetail.moduleName }}
            </el-tag> -->
            <el-tag type ="info" size = "mini" v-if="viewOneStudentDetail.examState == 1" >
              未开考
            </el-tag>
            <el-tag type ="success" size = "mini" v-else-if="viewOneStudentDetail.examState == 2" >
              已开考
            </el-tag>
            <el-tag type ="danger" size = "mini" v-else>
              已结束
            </el-tag>
          </div>
          <div  class="clearfix">
            <el-tag type ="info" size = "mini" v-if="viewOneStudentDetail.usrState == 1" >
              未答題
            </el-tag>
            <el-tag type ="success" size = "mini" v-else-if="viewOneStudentDetail.usrState == 2" >
              考试中
            </el-tag>
            <el-tag type ="danger" size = "mini" v-else>
              已交卷
            </el-tag>
            <!-- <el-tag type ='warning' size="mini" v-if="viewOneStudentDetail.usrState == 2" style="cursor: pointer;" @click = sendPaper(viewThemeOneDetail.id)>交卷</el-tag> -->
            <el-tag :type ="viewOneStudentDetail.examResult == 0 ? 'danger': 'success'" size="mini" v-if="viewOneStudentDetail.usrState == 3">
              {{ viewOneStudentDetail.result == 0 ? '不合格': '合格' }}
            </el-tag>
            <el-tag type ="mini" v-if="viewOneStudentDetail.usrState == 3">
              {{ viewOneStudentDetail.score }} 分
            </el-tag>
          </div>
            <div>
              <span style="margin-top : 5px">总分数: {{ viewOneStudentDetail.totalScore }}分; </span>
              <span style="margin-top : 5px">及格分数:{{ viewOneStudentDetail.passScore }}分; </span>
              <span style="margin-top : 5px">考试时长:{{ viewOneStudentDetail.duration }}分钟; </span>
              <div style="margin-top : 5px">注意:少选，多选，错选不得分 </div>
            </div>
        </el-card>
        <el-card style="height:calc(60vh - 10px); text-align: left; margin-top:calc(1vh);overflow:auto;">
          <div v-for = "(item,index) in viewOneStudentDetail.qtList" :key="index" style="margin-top:10px">
            <el-tag type ="mini"> {{item.answerCheckType}}</el-tag><span style="padding-left:10px;">{{'共' +item.qbList.length+ '题,' }}</span>
            <span >{{'每题' +item.oneScore+ '分,'}}</span>
            <span>{{'共' + (item.qbList.length * item.oneScore) + '分' }}</span>
            <el-checkbox-group v-model="viewOneStudentPaperCheckList"  @change="selectedStudentOne">
              <el-checkbox   v-for = "(ite,index) in item.qbList" :key="ite.id"  
              :label="ite.examQuestionId.toString()" :style = "answerCheckList['$$' +ite.examQuestionId ].length  == 0 ? 'color :rgb(208, 82, 82)': 'color:rgb(12, 239, 12)' "> 
                {{index + 1}}  
              </el-checkbox>
            </el-checkbox-group>
          </div>
        </el-card>
      </el-col>
      <el-col :span="17">
        <el-card style="height:calc(86vh - 19px); text-align: left; margin-top:10px;margin-left:20px; overflow:auto;">
          <div slot="header" class="clearfix">
          <el-tag type="warning">{{ qbOneStudentView.uniqNo }}</el-tag>
          <el-tag>{{ qbOneStudentView.moduleName }}</el-tag>
          <el-tag type="success">{{  qbOneStudentView.answerCheckType }}</el-tag>
        </div>
        <div style ="margin-top: 10px;" >
          <el-tag type="warning">问题</el-tag>
          <span style ="margin-left: 10px;">{{qbOneStudentView.question }}</span>
        </div>
        <div style ="margin-top: 10px;" v-if = "qbOneStudentView.imageUrlList.length > 0"> 
          <el-tag type="warning" style="padding-top: 0px">图片</el-tag>
          <el-badge  v-for="(item,index) in qbOneStudentView.imageUrlList" :key = "index"  :value="index + 1" class="item">
            <el-image   
              style="width: 100px; height: 100px;margin-left: 10px; "
              :src="item.url"
              :fit="'fit'"></el-image>
          </el-badge>
          </div>
          <div style ="margin-top: 10px;">
            <el-checkbox-group v-model="answerCheckList['$$' + qbOneStudentView.examQuestionId]" >
              <el-tag type="warning">选项</el-tag>
              <el-checkbox disabled style ="margin-left: 10px;"  v-for="(item,index ) in qbOneStudentView.optionValueArr" :label="index.toString()" :key="index">{{item}}</el-checkbox>
            </el-checkbox-group>
          </div>
          <!-- <div style ="margin-top: 10px;">
            <el-tag type="warning">考生答案</el-tag>
            <span style ="margin-left: 10px;"> {{qbOneStudentView.learnAnswer }}</span>
          </div > -->

          <div style ="margin-top: 10px;" v-if ="qbOneStudentView.learnAnswer != null && qbOneStudentView.learnAnswer != ''" >
              <el-tag type="warning">考生答案</el-tag>
              <span style ="margin-left: 10px;">{{qbOneStudentView.learnAnswer }}</span>
              <el-button   style ="margin-left: 50px;" size="mini"  :type="qbOneStudentView.learnAnswer == qbOneStudentView.answer ? 'success':'danger'"
               :icon="qbOneStudentView.learnAnswer == qbOneStudentView.answer  ? 'el-icon-check': 'el-icon-close'" circle></el-button>
          </div>
          <div style ="margin-top: 10px;">
            <el-tag type="warning">答案</el-tag>
            <span style ="margin-left: 10px;"> {{qbOneStudentView.answer }}</span>
          </div >
          <div style ="margin-top: 10px;">
            <el-tag type="warning">解析</el-tag>
            <span style ="margin-left: 10px;"> {{qbOneStudentView.analysis }}</span>
          </div>
        </el-card>
      </el-col>
    </el-dialog>
  </el-card>
</template>                     
<script>
  // 引入组件
import axios from  '@/api/axiosConfig'
import {stringIsNullOrEmpty,regCheck} from  '@/api/utils'
import {PAGE_SIZE,ConstAnswerCheckTypeList,themeConfigState,regInteger,MESSAGE_DURATION,fileType,fileAreaType,roleType,regEmail,regMobilePone} from  '@/api/constant'
export default {
    name : 'pc_ctr_exam_theme_list',
    data() {
    return {
      answerCheckTypes: ConstAnswerCheckTypeList,
      viewPaperCheckList:[],
      searchFactor: {
        theme: '',
        active :'',
        basicState :''
      },
      searchTitleFactor: {
        uniqNo:'',
        selected : '',
        question :'',
        moduleId : '',
        answerCheckType :'',
        examQuestionTypeId : '',
        index :''
      },
      searchUserFactor: {
        selected : '',
        fullName: '',
        userName: '',
        deptId :'',
        examThemeId:'',
        deptOptions : []
      },
      dialogVisual:{
        initExamThemeVisual: false,
        configPagerVisual : false,
        configTitleVisual : false,
        configUserVisual : false,
        viewPaperVisual : false,
        reportPaperVisual : false,
        oneStudentPaperVisual : false
      },
      viewOneStudentPaperCheckList:[],
      viewOneStudentDetail: {
        userName:'',
        fullName:'',
        deptName:'',
        id : '',
        theme:'',
        // moduleName :'',
        usrState :'',
        score:'',
        beginExamTime :'',
        commitExamTime :'',
        totalScore:'',
        passScore:'',
        examResult :'',
        duration :'',
        qtList :[]
      },
      qbOneStudentView :{
        examQuestionId :'',
        checkedOptList:[],
        analysis:'',
        answer:'',
        question :'',
        optionValueArr:[],
        moduleName:'',
        uniqNo:'',
        answerCheckType :'',
        imageUrlList :[]
      },
      answerCheckList:{},
      viewThemeOneDetail: {
        theme:'',
        // moduleName :'',
        totalScore:'',
        passScore:'',
        duration :'',
        qtList :[]
      },
      reportThemeOneDetail: {
        theme:'',
        // moduleName :'',
        totalScore:'',
        passScore:'',
        duration :'',
        beginTime :'',
        endTime :'',
        state:'',
        totalUserPer:0,
        totalUserCount:0,
        totalStudentPer: 0,
        totalStudentCount:0,
        passStudentPer:0,
        passStudentCount:0,
        completeExamStudentPer : 0,
        completeExamStudentCount:0,
        unExamStudentPer: 0,
        unExamStudentCount:0,
        inExamStudentPer:0,
        inExamStudentCount:0,
        overTimeStudentPer:0,
        overTimeStudentCount:0
      },

      searchUserExamFactor: {
        examThemeId :'',
        deptId : '',
        fullName :'',
        usrName :'',
        result :'',
        usrState:'',
      },
      reportUserExamTable :[],
      qbView :{
        checkedOptList:[],
        analysis:'',
        answer:'',
        question :'',
        optionValueArr:[],
        moduleName:'',
        uniqNo:'',
        answerCheckType :'',
        imageUrlList :[]
      },
      configPagerForm : {
        questionConfigList :[],
        totalScore:'',
        state:'',
        examThemeId :'',
        row :''
      },
      tableData: [],
      tableTitleData: [],
      tableUserData:[],
      pager:{
        totalCount:0,
        pageSize : PAGE_SIZE
      },
      userPager:{
        totalCount:0,
        curPage : 0,
        pageSize : PAGE_SIZE
      },
      titlePager:{
        totalCount:0,
        curPage : 0,
        pageSize : PAGE_SIZE
      },
      reportPager:{
        totalCount:0,
        curPage : 0,
        pageSize : 10
      },
      qmInfoList :[],
      initFormExamTheme :{
        theme :'',
        startDate:'',
        endDate :'',
        // moduleId:'',
        beginTime :'08:00:00',
        endTime:'08:00:00',
        duration :'',
        quantity:'',
        totalScore:'100',
        passScore :'60',
        desc :'',
        basicState :false
      },
      editFormExamTheme :{
        id:'',
        theme :'',
        startDate:'',
        endDate :'',
        // moduleId:'',
        beginTime :'',
        endTime:'',
        duration :'',
        quantity:'',
        totalScore:'',
        passScore :'',
        desc :'',
        basicState :false
      }
    }
  },
  methods : {
    handleCommandExam(obj){
      console.log(obj)
      let{row,  examLocalCount} = obj
      let{userId, usrName,fullName, examId , deptName, examCount } = row
      this.viewOneStudentDetail.usrName = usrName
      this.viewOneStudentDetail.fullName = fullName
      this.viewOneStudentDetail.deptName = deptName
      if(examLocalCount == examCount){
        this.handleViewOneStudentPaper(userId, examId , null)
      }else{
        this.handleViewOneStudentPaper(userId, examId , examLocalCount)
      }
    
    },
    formatTotalCount(percentage) {
      return '研究院共(' + this.reportThemeOneDetail.totalUserCount + ')人'
    },
    formatTotalStudentCount(percentage) {
      return '考生一共('+ this.reportThemeOneDetail.totalStudentCount+'/'+this.reportThemeOneDetail.totalUserCount+ ')人'
    },
    formatCompleteStudentCount(percentage) {
      return '完成考试('+ this.reportThemeOneDetail.completeExamStudentCount+'/'+this.reportThemeOneDetail.totalStudentCount+ ')人'
    },
    formatPassStudentCount(){
      return '通过考试('+ this.reportThemeOneDetail.passStudentCount+'/'+this.reportThemeOneDetail.totalStudentCount+ ')人'
    },
    formatUnExamStudentCount(){
      return '未考试('+ this.reportThemeOneDetail.unExamStudentCount+'/'+this.reportThemeOneDetail.totalStudentCount+ ')人'
    },
    formatInExamStudentCount(){
      return '考试中('+ this.reportThemeOneDetail.inExamStudentCount+'/'+this.reportThemeOneDetail.totalStudentCount+ ')人'
    },
    formatOverExamStudentCount(){ 
      return '超时未交卷('+ this.reportThemeOneDetail.overTimeStudentCount+'/'+this.reportThemeOneDetail.totalStudentCount+ ')人'
    },

    clearPaperViewForm(){
      this.viewThemeOneDetail.theme = ''
      this.viewThemeOneDetail.totalScore = ''
      this.viewThemeOneDetail.passScore = ''
      this.viewThemeOneDetail.duration = ''
      this.viewThemeOneDetail.qtList.splice(0)
      this.viewPaperCheckList.splice(0)
      this.clearViewQbForm()
    },
    clearPaperReportForm(){
      this.reportUserExamTable.splice(0)
      this.searchUserExamFactor.examThemeId  = ''
      this.searchUserExamFactor.deptId = ''
      this.searchUserExamFactor.fullName =''
      this.searchUserExamFactor.usrName = ''
      this.searchUserExamFactor.result =''
      this.searchUserExamFactor.usrState = ''
    },
    handleCommandOneStudent(command){
      let index = command.index
      let row = command.data
      let event = command.event
      switch(event){
        case 'seeOneStudentPaper' :
          this.seeOneStudentPaper(index,row)
          break
        case 'getOneStudentPaper':
          this.getOneStudentPaper(index,row)
          break
      }
    },
    getOneStudentPaper(index,row){
      let url = "/bc/exa/exam/examCommitPaper"
      let dat ={
        themeId:row.id,student:false
      }
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'success',
            duration: MESSAGE_DURATION
          }) 
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        }) 
      })

    },
    seeOneStudentPaper(index,row){
      
      this.viewOneStudentDetail.usrName = row.usrName
      this.viewOneStudentDetail.fullName = row.fullName
      this.viewOneStudentDetail.deptName = row.deptName
      let examThemeId = this.searchUserExamFactor.examThemeId
      this.handleViewOneStudentPaper(row.userId, examThemeId)
    },
    handleViewOneStudentPaper( id, examThemeId,examCount){
      let dat = {
        id : examThemeId, student:false,studentId: id,examCount
      }
      let url = "/bc/exa/exam/getExamThemeOneDetail"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.dialogVisual.oneStudentPaperVisual = true
          let dat = response.data.data
          this.viewOneStudentDetail.state = dat.state
          this.viewOneStudentDetail.score = dat.score
          this.viewOneStudentDetail.usrState = dat.usrState
          this.viewOneStudentDetail.result = dat.result
          this.viewOneStudentDetail.examState = dat.examState
          this.viewOneStudentDetail.beginExamTime = dat.beginExamTime
          this.viewOneStudentDetail.commitExamTime = dat.commitExamTime
          this.viewOneStudentDetail.examResult = dat.examResult
          this.viewOneStudentDetail.id = dat.id
          this.viewOneStudentDetail.theme = dat.theme
          this.viewOneStudentDetail.totalScore = dat.totalScore
          this.viewOneStudentDetail.passScore = dat.passScore
          this.viewOneStudentDetail.duration = dat.duration
          this.viewOneStudentDetail.qtList.splice(0)
          this.viewOneStudentDetail.qtList = [... dat.qtList]
          this.viewOneStudentPaperCheckList = []
          let first = this.viewOneStudentDetail.qtList[0].qbList[0].examQuestionId
          for(let  i = 0 ;i< this.viewOneStudentDetail.qtList.length ; i++){
            let qt =this.viewOneStudentDetail.qtList[i]
            for(let  j = 0 ;j< qt.qbList.length ; j++){
              let qb = qt.qbList[j]
              let arr = []
              // 保证动态绑定
              if(dat.state >  1 && qb.learnAnswer != null && qb.learnAnswer != ''){
                arr = [... qb.learnAnswer]
              }
              this.$set(this.answerCheckList,'$$' + qb.examQuestionId,arr)
            }
          }
          setTimeout(()=> this.handleViewOneStudentQb(first.toString()),300)
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        }) 
      })

    },
    handleCommand(command){
      let index  = command.index
      let row = command.data
      let event = command.event
      switch(event){
        case 'delete' :
          this.handleDelete(index,row)
          break
        case 'handleViewPaper':
          this.handleViewPaper(index,row.id)
          break
        case 'doActiveExamTheme' :
          this.doActiveExamTheme(index,row)
          break
        case 'handleConfigPaper' :
          this.handleConfigPaper(index,row)
          break
        case 'sendPaper' :
          this.sendPaper(index,row)
          break
        case 'handleEdit' :
          this.handleEdit(index,row)
          break
        case 'handleViewReport' :
          this.handleViewReport(index,row)
          break
      }
    },
    onResultSearch(){
      this.examListLoad(1)
    },

    examListLoad(pageNo){
      let url = "/bc/exa/exam/selectUserExamPage"
      let  {
        examThemeId,
        deptId ,
        fullName ,
        usrName,
        result ,
        usrState } =  this.searchUserExamFactor
      let dat = {student:false,
        deptId ,
        fullName ,
        usrName,
        result ,
        usrState,
        examThemeId,
        pageNo,pageSize : 10}
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          if( response.data.data.data.length !== 0){
            this.reportUserExamTable.splice(0)
            response.data.data.data.forEach(t=>{
              this.reportUserExamTable.push(t)
            })
            this.reportPager.totalCount = response.data.data.totalDataCount
            this.reportPager.curPage = pageNo
          }else{
            this.$message({
              showClose: true,
              message: '未查询到考生信息！',
              type: 'warning',
              duration: MESSAGE_DURATION
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    selectedOne( val){
      this.clearViewQbForm()
      if(this.viewPaperCheckList.length == 0){
          return
      }
      let last= this.viewPaperCheckList.pop();
      this.viewPaperCheckList = []
      setTimeout(()=> this.handleViewQb(last),300)
    },

    handleViewQb(last){
      this.viewPaperCheckList.push(last)
      let row = '';
      let qtList = this.viewThemeOneDetail.qtList
      for(let i = 0; i< qtList.length ; i++){
        let qbList = qtList[i].qbList
        for(let j = 0; j < qbList.length; j++  ){
          if( qbList[j].id == last ){
            row = qbList[j]
            break
          }
        }
      }
      this.qbView.analysis = row.analysis
      this.qbView.answer = row.answer
      this.qbView.question = row.question 
      this.qbView.moduleName=row.moduleName
      this.qbView.uniqNo=row.uniqNo
      this.qbView.answerCheckType =row.answerCheckType
      this.qbView.optionValueArr.splice(0)
      for(let i = 0; i< 5; i++){
        let v =  row['option' + (i + 1)]
        if(v != null &&  v != '') {
          let ch = String.fromCharCode(i + 1 + 64)
          this.qbView.optionValueArr.push(ch + "."+ v + ";")
        }
      }
      let countImage = row.countImage 
      this.qbView.imageUrlList.splice(0)
      for(let i = 0; i< countImage; i++){
        this.qbView.imageUrlList.push({name: row.id , url : row['fileUrl'+ (i+1)]})
      }
    },

    selectedStudentOne( val){
      this.clearViewOneStudentQbForm()
      if(this.viewOneStudentPaperCheckList.length == 0){
          return
      }
      let last= this.viewOneStudentPaperCheckList.pop();
      this.viewOneStudentPaperCheckList = []
   
      setTimeout(()=> this.handleViewOneStudentQb(last),300)
    },
    handleViewOneStudentQb(last){
      this.viewOneStudentPaperCheckList.push(last)
      let row = '';
      let qtList = this.viewOneStudentDetail.qtList
      for(let i = 0; i< qtList.length ; i++){
        let qbList = qtList[i].qbList
        for(let j = 0; j < qbList.length; j++  ){
          if( qbList[j].examQuestionId == last ){
            row = qbList[j]
            break
          }
        }
      }
      
      this.qbOneStudentView.learnAnswer = row.learnAnswer
      this.qbOneStudentView.examQuestionId = row.examQuestionId
      this.qbOneStudentView.analysis = row.analysis
      this.qbOneStudentView.answer = row.answer
      this.qbOneStudentView.question = row.question 
      this.qbOneStudentView.moduleName=row.moduleName
      this.qbOneStudentView.uniqNo=row.uniqNo
      this.qbOneStudentView.answerCheckType =row.answerCheckType
      this.qbOneStudentView.optionValueArr.splice(0)
      for(let i = 0; i< 5; i++){
        let v =  row['option' + (i + 1)]
        if(v != null &&  v != '') {
          let ch = String.fromCharCode(i + 1 + 64)
          this.qbOneStudentView.optionValueArr.push(ch + "."+ v + ";")
        }
      }
      let countImage = row.countImage 
      this.qbOneStudentView.imageUrlList.splice(0)
      for(let i = 0; i< countImage; i++){
        this.qbOneStudentView.imageUrlList.push({name: row.id , url : row['fileUrl'+ (i+1)]})
      }
    },
    
    clearViewQbForm(){
      this.qbView.analysis = ''
      this.qbView.answer = ''
      this.qbView.question = ''
      this.qbView.moduleName = ''
      this.qbView.uniqNo= ''
      this.qbView.answerCheckType = ''
      this.qbView.optionValueArr.splice(0)
      this.qbView.imageUrlList.splice(0)
    },
    clearViewOneStudentQbForm(){
      this.qbOneStudentView.learnAnswer = ''
      this.qbOneStudentView.examQuestionId = ''
      this.qbOneStudentView.analysis = ''
      this.qbOneStudentView.answer = ''
      this.qbOneStudentView.question = ''
      this.qbOneStudentView.moduleName = ''
      this.qbOneStudentView.uniqNo= ''
      this.qbOneStudentView.optionValueArr.splice(0)
      this.qbOneStudentView.imageUrlList.splice(0)
    },

    clearOneStudentPaperViewForm(){
      // this.viewOneStudentDetail.moduleName = ''
      this.viewOneStudentDetail.fullName = ''
      this.viewOneStudentDetail.usrName = ''
      this.viewOneStudentDetail.deptName = ''
      this.viewOneStudentDetail.usrState = ''
      this.viewOneStudentDetail.score = ''
      this.viewOneStudentDetail.beginExamTime = ''
      this.viewOneStudentDetail.commitExamTime = ''
      this.viewOneStudentDetail.examResult = ''
      this.viewOneStudentDetail.id = ''
      this.viewOneStudentDetail.theme = ''

      this.viewOneStudentDetail.totalScore = ''
      this.viewOneStudentDetail.passScore = ''
      this.viewOneStudentDetail.duration = ''
      this.viewOneStudentDetail.qtList.splice(0)
      this.clearViewOneStudentQbForm()
    },
    handleViewReport(index, row){
      this.dialogVisual.reportPaperVisual = true
      this.searchUserExamFactor.examThemeId = row.id
      if(this.searchUserFactor.deptOptions.length == 0) {
          setTimeout(()=>{this.deptListLoad()},200)
      }
      setTimeout(()=>{this.examListLoad(1),200})
      let dat = {
        id : row.id,
      }
      let url = "/bc/exa/exam/getExamThemeOneSum"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.reportThemeOneDetail = {...response.data.data }
          if(this.reportThemeOneDetail.totalUserCount != 0){
            this.reportThemeOneDetail.totalStudentPer = this.reportThemeOneDetail.totalStudentCount * 100 / this.reportThemeOneDetail.totalUserCount
            this.reportThemeOneDetail.totalUserPer = 100
          }
          if(this.reportThemeOneDetail.totalStudentCount != 0){
            //this.reportThemeOneDetail.totalStudentPer = this.reportThemeOneDetail.passStudentCount * 100 / this.reportThemeOneDetail.totalStudentCount
            this.reportThemeOneDetail.passStudentPer = this.reportThemeOneDetail.passStudentCount * 100 / this.reportThemeOneDetail.totalStudentCount
            this.reportThemeOneDetail.completeExamStudentPer = this.reportThemeOneDetail.completeExamStudentCount* 100 / this.reportThemeOneDetail.totalStudentCount
            this.reportThemeOneDetail.unExamStudentPer = this.reportThemeOneDetail.unExamStudentCount* 100 / this.reportThemeOneDetail.totalStudentCount
            this.reportThemeOneDetail.inExamStudentPer = this.reportThemeOneDetail.inExamStudentCount * 100/ this.reportThemeOneDetail.totalStudentCount
            this.reportThemeOneDetail.overTimeStudentPer = this.reportThemeOneDetail.overTimeStudentCount * 100/ this.reportThemeOneDetail.totalStudentCount
          }
       
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        }) 
      })
    },
    handleViewPaper(index, id){
      this.dialogVisual.viewPaperVisual = true
      let dat = {
        id : id,
        student :false
      }
      let url = "/bc/exa/exam/getExamThemeOneDetail"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          let dat  = response.data.data
          // this.viewThemeOneDetail.moduleName = dat.moduleName
          this.viewThemeOneDetail.id = dat.id
          this.viewThemeOneDetail.theme = dat.theme
          this.viewThemeOneDetail.totalScore = dat.totalScore
          this.viewThemeOneDetail.passScore = dat.passScore
          this.viewThemeOneDetail.duration = dat.duration
          this.viewThemeOneDetail.qtList.splice(0)
          
          this.viewThemeOneDetail.qtList = [... dat.qtList]

          this.viewPaperCheckList.splice(0)
          
          if( this.viewThemeOneDetail.qtList[0].qbList.length > 0){
            let first = this.viewThemeOneDetail.qtList[0].qbList[0].id
            setTimeout(()=> this.handleViewQb(first.toString()),300)
          }
         
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        }) 
      })
    },
    // 选择试卷
    handleSelected(index, row){
      let selected = row.selected === 0 ? 1 : 0
      let dat = {
        examQuestionTypeId: this.searchTitleFactor.examQuestionTypeId,
        selected: selected,
        questionId :  row.id
      }
      let url = "/bc/exa/question/manualCheck"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.$message({
              showClose: true,
              message: '操作成功!',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            row.selected = selected
            this.$set(this.tableTitleData, index, row);
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err)=> {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
      })
    },

    indexMethod(index){
      return  index + 1
    },
    formatContent(row , index){
      let res = '';
      for(let i = 0; i< 5; i++){
        let v =  row['option' + (i + 1)]
        if(v != null &&  v != '') {
          let ch = String.fromCharCode(i+1 + 64)
          res +=  ch + "."+ v + ";"
        }
      }
      return res
    },
    handleEdit(index,row){
      this.dialogVisual.editExamThemeVisual = true
      if(row.beginTime != null && row.beginTime != ''){
          let sd =  row.beginTime.split(" ")
          this.editFormExamTheme.startDate= sd[0]
          this.editFormExamTheme.beginTime = sd[1]
      }

      if(row.endTime != null && row.endTime != ''){
          let sd =  row.endTime.split(" ")
          this.editFormExamTheme.endDate= sd[0]
          this.editFormExamTheme.endTime = sd[1]
      }
      this.editFormExamTheme.id = row.id
      this.editFormExamTheme.theme = row.theme
      // this.editFormExamTheme.moduleId= row.moduleId
      this.editFormExamTheme.duration = row.duration
      this.editFormExamTheme.quantity= row.quantity
      this.editFormExamTheme.totalScore= row.totalScore
      this.editFormExamTheme.passScore= row.passScore
      this.editFormExamTheme.desc = row.desc
      this.editFormExamTheme.basicState = row.basicState == 1
    },
    // 配置试卷
    handleConfigPaper(index,row){
      this.configPagerForm.questionConfigList.splice(0)
      //如果是新出的试卷直接配配置页面
      if(row.state == 1 ){
        ConstAnswerCheckTypeList.forEach(t=>{
          this.configPagerForm.questionConfigList.push({ 
            examThemeId : row.id,
            answerCheckType:t,
            oneScore :"",
            quantity:"",
            selectCount : 0
          })
        })
      }else{
        // 否者加载数据库的试题配置
        this.examThemeTypeListLoad(row.id)
      }
      this.configPagerForm.state = row.state
      this.configPagerForm.examThemeId = row.id
      this.configPagerForm.totalScore = row.totalScore
      this.configPagerForm.row = row 
      this.dialogVisual.configPagerVisual = true
    },
   
   
    handleCurrentChange(val){
      this.examThemeListLoad(val);
    },
    handleReportChange(val){
      this.examListLoad(val);
    },   
    handleTitleCurrentChange(val){
      this.qbListLoad(val)
    },

    handleUserCurrentChange(val){
      this.userListLoad(val)
    },
    examThemeListLoad(pageNo){
      let url = "/bc/exa/exam/examThemePage"
      let { 
          theme,
          active,
          basicState
      } = this.searchFactor 
      let dat0 = {
          pageSize: PAGE_SIZE,
          theme,
          pageNo,
          active,basicState
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data
          if(dat.data.length !== 0){
              this.tableData = [];
              dat.data.forEach(t=>this.tableData.push(t))
              this.pager.totalCount = dat.totalDataCount;
          } else {
            this.$message({
              showClose: true,
              message: '未查询到考试信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        });
    },

    // 加载试卷题目类型
    examThemeTypeListLoad(examThemeId){
      let url = "/bc/exa/config/questionType/getByExamThemeId"
      let dat0 = {
        id: examThemeId
      }
      let s = JSON.stringify(dat0)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.length !== 0){
              this.configPagerForm.questionConfigList = []
              dat.forEach(t=> this.configPagerForm.questionConfigList.push(t))
          } else {
            this.$message({
              showClose: true,
              message: '未查询到考试信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        });
    },
    onSearch(){
      this.examThemeListLoad(1)
    },
    onQbSearch(){
      this.qbListLoad(1)
    },
    onUserSearch(){
      this.userListLoad(1)
    },

    sendAllPeople(){
      let url = "/bc/exa/themeUser/bindAllActiveUser" 
      let dat0 = {
        id: this.searchUserFactor.examThemeId
      }
      let s = JSON.stringify(dat0)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            showClose: true,
            message: '操作成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          setTimeout(()=>{ this.userListLoad(1)},200);
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
      });
    },
    handleSendPaper(index,row){
      let url = "/bc/exa/themeUser/bind" 
      let selected = row.selected === 0 ? 1 : 0
      let dat0 = {
        themeId: this.searchUserFactor.examThemeId,
        userId : row.id,
        selected
      }
      let s = JSON.stringify(dat0)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0) {
          this.$message({
            showClose: true,
            message: '操作成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          row.selected = selected
          this.$set(this.tableUserData, index, row);
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      });
    },
    handleCreateExam(){
      this.dialogVisual.initExamThemeVisual = true;
    },
    handleDelete(index, row){
      this.$confirm('即将删除主题['+row.theme+']的考试!', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.doDeleteExamTheme(row)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '取消删除！'
        });
      })
    },
    doDeleteExamTheme(row){
      let datBat = {id: row.id}
      let url = "/bc/exa/exam/examThemeDelete"
      let s = JSON.stringify(datBat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '删除成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.examThemeListLoad(1);
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    doActiveExamTheme(index,row){
      let actState = row.active === 0 ? 1 : 0
      let dat = {
        id: row.id,
        active: actState
      }
      let url = "/bc/exa/exam/examThemeActive"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '操作成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          this.examThemeListLoad(1);
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    ensureCreateConfig(){
      if(!this.testScore()){
        return 
      }
      let url = "/bc/exa/config/questionType/save"
      let s = JSON.stringify(this.configPagerForm.questionConfigList)  
      
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.configPagerForm.questionConfigList.splice(0)
          this.configPagerForm.state = themeConfigState.CONFIG_TITLE
          response.data.data.forEach(t=>{
            this.configPagerForm.questionConfigList.push(t)
          })
          this.configPagerForm.row.state = themeConfigState.CONFIG_TITLE
          this.$message({
            showClose: true,
            message: '试题类型配置成功',
            type: 'success',
            duration: MESSAGE_DURATION
          })
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err)=> {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })

    },
    ensureEdit(){
      let {theme,startDate,beginTime,quantity,
        endDate,endTime, duration,totalScore,passScore,
        id,
        desc
      } = this.editFormExamTheme
      try{ 
        // stringIsNullOrEmpty(moduleId ,'请选择试题模块!')
        stringIsNullOrEmpty(theme ,'请选考试主题!')
        stringIsNullOrEmpty(startDate ,'请选开始日期!')
        stringIsNullOrEmpty(beginTime ,'请选开始时间!')
        stringIsNullOrEmpty(endDate ,'请选择结束日期!')
        stringIsNullOrEmpty(endTime ,'请选择结束时间!')
        stringIsNullOrEmpty(duration ,'请输入考试时长!')
        stringIsNullOrEmpty(totalScore ,'请输入总分数!')
        stringIsNullOrEmpty(passScore ,'请输入合格分数!')
        stringIsNullOrEmpty(quantity ,'请输入题目数量!')
        regCheck(regInteger, duration,  '考试时长为正整数')
        regCheck(regInteger, totalScore,  '总分数为正整数')
        regCheck(regInteger, passScore,  '通过分数为正整数')
        regCheck(regInteger, quantity,  '题目数量为正整数')
      }catch (e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return
      }
      beginTime = startDate + ' ' + beginTime
      endTime = endDate + ' ' + endTime
      let dat = {theme,beginTime,quantity,id,
        endTime, duration,totalScore,passScore,desc}
      let url = "/bc/exa/exam/updateExamTheme"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.dialogVisual.editExamThemeVisual = false
            this.$message({
              showClose: true,
              message: '修改考试信息成功',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            this.clearInitExamThemeForm()
            setTimeout(()=>{
              this.examThemeListLoad(1)
            })
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch((err)=> {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
      })
    },
    ensureCreate(){
      let {theme,startDate,beginTime,quantity,
        endDate,endTime, duration,totalScore,passScore,
        desc,basicState
      } = this.initFormExamTheme;
      try{ 
        // stringIsNullOrEmpty(moduleId ,'请选择试题模块!')
        stringIsNullOrEmpty(theme ,'请选考试主题!')
        stringIsNullOrEmpty(startDate ,'请选开始日期!')
        stringIsNullOrEmpty(beginTime ,'请选开始时间!')
        stringIsNullOrEmpty(endDate ,'请选择结束日期!')
        stringIsNullOrEmpty(endTime ,'请选择结束时间!')
        stringIsNullOrEmpty(duration ,'请输入考试时长!')
        stringIsNullOrEmpty(totalScore ,'请输入总分数!')
        stringIsNullOrEmpty(passScore ,'请输入合格分数!')
        stringIsNullOrEmpty(quantity ,'请输入题目数量!')
        regCheck(regInteger, duration,  '考试时长为正整数')
        regCheck(regInteger, totalScore,  '总分数为正整数')
        regCheck(regInteger, passScore,  '通过分数为正整数')
        regCheck(regInteger, quantity,  '题目数量为正整数')
      }catch (e){
        this.$message({
          showClose: true,
          message: e,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return
      }
      beginTime = startDate +' ' + beginTime
      endTime = endDate +' ' + endTime
      let dat = {theme,beginTime,quantity,
        endTime, duration,totalScore,passScore,desc,
         basicState: basicState? 1:0}
      let url = "/bc/exa/exam/examThemeSave"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.$message({
              showClose: true,
              message: '初始化考试成功',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            this.clearInitExamThemeForm()
            setTimeout(()=>{
              this.examThemeListLoad(1)
            })
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch((err)=> {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          }) 
      })
    },

    ensureUpdateConfig(){
      if(!this.testScore()){
        return 
      }
      let url = "/bc/exa/config/questionType/update"
      let s = JSON.stringify(this.configPagerForm.questionConfigList)  
      axios.post(url, s).then((response) => {
      if (response.data.code === 0){
        this.$message({
          showClose: true,
          message: '题型配置修改成功',
          type: 'success',
          duration: MESSAGE_DURATION
        })
       // this.examThemeListLoad(1);
      } else {
        this.$message({
          showClose: true,
          message: response.data.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      }
    }).catch( (err)=> {
      this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    randomOtherTitle(){
      let dat = {
        examThemeId: this.configPagerForm.examThemeId
      }
      let url = "/bc/exa/question/randomCheck"
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
          if (response.data.code === 0){
            this.$message({
              showClose: true,
              message: '操作成功!',
              type: 'success',
              duration: MESSAGE_DURATION
            })
            setTimeout(()=>{
                this.examThemeTypeListLoad(this.configPagerForm.examThemeId)
            })
          } else {
            this.$message({
              showClose: true,
              message: response.data.message,
              type: 'error',
              duration: MESSAGE_DURATION
            })
          }
        }).catch( (err) => {
          this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
          }) 
      })
    },
    configTitle(checkType,index){
      this.searchTitleFactor.answerCheckType = checkType
      this.searchTitleFactor.index = index
      this.searchTitleFactor.examQuestionTypeId = this.configPagerForm.questionConfigList[index].id
      this.qbListLoad(1)
      this.dialogVisual.configTitleVisual = true
    },


    defaultConfig(){

      this.configPagerForm.questionConfigList[0].quantity = 20
      this.configPagerForm.questionConfigList[0].oneScore= 2
      this.configPagerForm.questionConfigList[1].quantity = 10
      this.configPagerForm.questionConfigList[1].oneScore= 4
      this.configPagerForm.questionConfigList[2].quantity = 10
      this.configPagerForm.questionConfigList[2].oneScore= 2

    },

    sendPaper(index, row ){
      this.searchUserFactor.examThemeId = row.id
      if(this.searchUserFactor.deptOptions.length == 0 ){
        this.deptListLoad();
      }
      this.userListLoad(1)
      this.dialogVisual.configUserVisual = true
    },
    testScore(){
      let message = ""
      let totalScroe = 0
      try{

        for(let i = 0 ; i<this.configPagerForm.questionConfigList.length; i++){
          let item = this.configPagerForm.questionConfigList[i]
          stringIsNullOrEmpty(item.quantity, item.answerCheckType + "的题目数不能为空！")
          stringIsNullOrEmpty(item.oneScore, item.answerCheckType + "的分数不能为空！")
          regCheck(regInteger, item.quantity, item.answerCheckType + "的题目数必须是0和正整数！")
          regCheck(regInteger, item.oneScore, item.answerCheckType + "的题分数必须是0和正整数！")
          totalScroe += item.quantity * item.oneScore 
          message += item.answerCheckType + "总分: " + 
          item.quantity +" * "  + item.oneScore + " = " +  item.quantity * item.oneScore + ";"
        }
        message += "各题目总分:" +  totalScroe +";";

        if(totalScroe != this.configPagerForm.totalScore ){
          message += "但是该试题初始化总分数为" + this.configPagerForm.totalScore + ",请重新设置各个题目分数！"
          throw message;
        }
      }catch(err){
        this.$message({
          showClose: true,
          message: err,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
        return false;
      }

      message  ="测试通通过:" +message
      this.$message({
          showClose: true,
          message: message,
          type: "success",
          duration: MESSAGE_DURATION
        }) 
        return true
    },

    clearInitExamThemeForm(){
      this.dialogVisual.initExamThemeVisual = false
      this.initFormExamTheme.theme = ''
      this.initFormExamTheme.startDate= ''
      this.initFormExamTheme.endDate = ''
      // this.initFormExamTheme.moduleId =''
      this.initFormExamTheme.beginTime = '08:00:00'
      this.initFormExamTheme.endTime ='08:00:00'
      this.initFormExamTheme.duration = ''
      this.initFormExamTheme.quantity = ''
      this.initFormExamTheme.totalScore= '100'
      this.initFormExamTheme.passScore ='60'
      this.initFormExamTheme.desc =''
      this.initFormExamTheme.basicState = false
    },
    clearEditExamThemeForm(){
      this.dialogVisual.editExamThemeVisual = false
      this.editFormExamTheme.id = ''
      this.editFormExamTheme.theme = ''
      this.editFormExamTheme.startDate= ''
      this.editFormExamTheme.endDate = ''
      // this.editFormExamTheme.moduleId =''
      this.editFormExamTheme.beginTime = ''
      this.editFormExamTheme.endTime =''
      this.editFormExamTheme.duration = ''
      this.editFormExamTheme.quantity = ''
      this.editFormExamTheme.totalScore= ''
      this.editFormExamTheme.passScore =''
      this.editFormExamTheme.desc =''
      this.editFormExamTheme.basicState = false
    },
    clearPaperConfigForm(){
      this.configPagerForm.questionConfigList = []
      this.dialogVisual.configPagerVisual = false
      this.configPagerForm.examThemeId = ""
      this.configPagerForm.totalScore = ""
    },
    clearTitleConfigForm(){
      this.searchTitleFactor.selected =''
      this.searchTitleFactor.question =''
      this.searchTitleFactor.index =''
      this.searchTitleFactor.uniqNo =''
      this.searchTitleFactor.moduleId = ''
      this.searchTitleFactor.examQuestionTypeId =''
      this.titlePager.curPage = ''
      this.tableTitleData = []
      setTimeout(()=>{
        this.examThemeTypeListLoad(this.configPagerForm.examThemeId)
      })
    },
    clearUserPaperForm(){
      this.dialogVisual.configUserVisual = false
      this.searchUserFactor.examThemeId = ''
      this.searchUserFactor.selected =''
      this.searchUserFactor.fullName =''
      this.searchUserFactor.userName =''
      this.searchUserFactor.deptId =''
    },

    doActive (active, ids){
      let actState = active  ? 1 : 0
      let url = "/bc/exa/qb/qbActive/"+ actState
      let s = JSON.stringify(ids)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          this.$message({
            showClose: true,
            message: '操作成功!',
            type: 'success',
            duration: MESSAGE_DURATION
          })
          // this.$refs.multipleTable.clearSelection();
          setTimeout(()=>{
            this.examThemeListLoad(1);
          },200);
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        }) 
      })
    },
    // 加载知识模块
    qmListLoad(pageNo){
      let url = "/bc/exa/qm/qmPage"
      let dat0 = {
        pageSize: PAGE_SIZE,
        pageNo
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.data.length !== 0){
            dat.data.forEach(t=>{
                if(t.active == 1){
                  this.qmInfoList.push(t)
                }
              }
            )
          } else {
            this.$message({
              showClose: true,
              message: '未查询到安全知识模块信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch((err)=>{
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error',
          duration: MESSAGE_DURATION
        })
      });
    },
    qbListLoad(pageNo){
      let url = "/bc/exa/qb/qbPaperPage"
      let { 
          selected,
          question ,
          uniqNo,
          moduleId,
          examQuestionTypeId
      } = this.searchTitleFactor 
      let dat0 = {
          pageSize: PAGE_SIZE,
          pageNo,
          question,
          selected,
          uniqNo,
          moduleId,
          examQuestionTypeId
      }
      axios.post(url, dat0).then((response) => {
        if (response.data.code === 0) {
          let dat = response.data.data;
          if(dat.data.length !== 0){
              this.tableTitleData = [];
              dat.data.forEach(t=>this.tableTitleData.push(t))
              this.titlePager.totalCount = dat.totalDataCount;
          } else {
            this.$message({
              showClose: true,
              message: '未查询到题目信息！',
              type: 'info',
              duration: MESSAGE_DURATION
            })
          }
        }else{
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
        }).catch((err)=>{
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        });
    },
    formatGentle(row, index){
      if(row.gentle == 1){
          return '男';
      }else{
          return '女';
      }
    },
    deptListLoad(){
      let url = "/bc/exa/dept/getDeptTree"
      let dat = {}
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
        if (response.data.code === 0){
          if( response.data.data.length !== 0){
            response.data.data.forEach(t=>{
              if(t.level == 1){
                this.searchUserFactor.deptOptions.push({value: t.id,label: t.deptName })
              }
            })
          }else{
              this.$message({
                showClose: true,
                message: '团队列表未查询到数据！',
                type: 'warning',
                duration: MESSAGE_DURATION
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: response.data.message,
            type: 'error',
            duration: MESSAGE_DURATION
          })
        }
      }).catch( (err) => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            duration: MESSAGE_DURATION
        }) 
      })
    },
    userListLoad(pageNo){
      let url = "/bc/exa/usr/userPaperPage"
      let { 
        selected,
        userName,
        fullName,
        examThemeId,
        deptId
      } =  this.searchUserFactor 
      let dat = {
        pageSize: PAGE_SIZE,
        selected,
        fullName,
        userName,
        examThemeId,
        deptId,
        pageNo
      }
      let s = JSON.stringify(dat)  
      axios.post(url, s).then((response) => {
          if (response.data.code === 0) {
              let dat = response.data.data;
            if(dat.data.length !== 0){
              this.tableUserData = [];
              dat.data.forEach(t=>this.tableUserData.push(t))
              this.userPager.totalCount = dat.totalDataCount;
            } else {
              this.$message({
                showClose: true,
                message: '未查询到用户信息！',
                type: 'info',
                duration: MESSAGE_DURATION
              })
            }
          }else{
            this.$message({
                showClose: true,
                message: response.data.message,
                type: 'error',
                duration: MESSAGE_DURATION
            })
          }
        }).catch( (err) => {
            this.$message({
              showClose: true,
              message: err.message,
              type: 'error',
              duration: MESSAGE_DURATION
          })
      });
    }
  },
  
  created () {
    setTimeout(()=>{this.qmListLoad(1)},200)
    this.examThemeListLoad(1);
  },
  mounted(){
    
  },
  components: {
    
  }
}
</script>

<style lang="less" scoped>
 
  .item {
  margin-top: 10px;
  margin-right: 15px;
}

.el-card {
  height: 99%
}

.search-form{
  margin-top: 10px;
  text-align:left 
}

.text {
  font-size: 14px;
  color: #000;
}

/deep/.el-progress-bar {


  width : 50%
}
</style>
    


// WEBPACK FOOTER //
// src/pc_pages/pc_ctr_component/pc_ctr_exam_theme_list.vue